'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPen = function TiPen(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.5 12c0-2-0.7-3.9-2.2-5.3s-3.3-2.2-5.3-2.2c-2 0-3.9 0.7-5.3 2.1-0.1 0.1-13.3 13.3-13.3 13.3-0.6 0.6-1.2 1.5-1.6 2.5-0.3 0.8-3.3 9.8-3.9 11.6-0.2 0.6 0 1.2 0.4 1.7 0.3 0.3 0.7 0.5 1.2 0.5 0.2 0 0.3-0.1 0.5-0.1 1.8-0.6 10.8-3.6 11.6-3.9 1-0.4 1.9-1 2.5-1.6l3.6-3.6c0 0 0.1 0 0.1 0 1.1 0 2.1-0.4 3-1.2l7.5-7.5c1.1-1.2 1.4-2.8 0.9-4.3 0.2-0.6 0.3-1.3 0.3-2z m-19.7 17.3c-0.7 0.2-1.9 0.7-3.4 1.2l-2.9-2.9c0.5-1.5 1-2.7 1.2-3.4l5.1 5.1z m-6.9 0.1l1.7 1.7-2.5 0.8 0.8-2.5z m12.9-5.2l-4.1 4c-0.1 0.1-0.2 0.2-0.3 0.3l-5.9-5.9c0.1-0.1 0.2-0.2 0.3-0.3l11.9-11.9 4.5 4.5-6.1 6.2c-0.9 0.8-1 2.1-0.3 3.1z m10.1-8.3l-7.5 7.5c-0.2 0.2-0.4 0.3-0.6 0.3s-0.4-0.1-0.6-0.3c-0.3-0.3-0.3-0.8 0-1.1l7.5-7.5c0.4-0.4 0.9-0.4 1.2 0 0.3 0.3 0.3 0.8 0 1.1z m0.2-2.9c-0.9-0.3-1.9-0.1-2.5 0.6l-0.2 0.1-4.6-4.5 0.2-0.1c1.6-1.7 4.4-1.7 6-0.1 0.8 0.8 1.2 1.9 1.2 3 0 0.3 0 0.7-0.1 1z' })
        )
    );
};

exports.default = TiPen;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/pen.js
// module id = 3913
// module chunks = 0